<template>
  <x-page
    v-bind="{
      title: title,
      ...pageProps,
    }"
  >
    <div :class="[_.hd, ($slots.header || $scopedSlots.header) && _.custom]">
      <slot name="header" :total="total">
        <!-- 搜索栏 -->
        <x-goods-search-bar
          v-model="keyword"
          :class="_.searchBar"
          :query-keywords="getQueryKeywords"
          :update-on-click-keyword="true"
          @confirm="handleSearchConfirm"
        />
      </slot>

      <!-- 筛选栏 -->
      <x-goods-filter-bar
        v-if="!($slots.header || $scopedSlots.header)"
        v-model="filterForm"
        :has-filter="true"
        :search-id="searchId"
        :class="_.filterBar"
        :full="!!pageProps.transparentHeader"
      />
    </div>

    <!-- 筛选栏 -->
    <x-goods-filter-bar
      v-if="$slots.header || $scopedSlots.header"
      v-model="filterForm"
      :has-filter="true"
      :search-id="searchId"
      :class="[_.filterBar, _.custom]"
      :full="!!pageProps.transparentHeader"
    />

    <!-- 商品列表 -->
    <div :class="_.list">
      <x-goods-waterfall
        ref="goodsList"
        manual
        :empty-props="{
          type: '搜索',
          message: '抱歉，没有搜到你想要的～',
        }"
        :load="handleLoadData"
        :track="{
          from: martId ? '店铺首页' : '搜索商品',
        }"
      />
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiSearchMartSearchSearchCommodity,
    apiSearchMartSearchSearchKeyword,
  } from '@/api'
  import { currentChannelId } from '@/channel'
  import { currentMall } from '@/mall'
  import { historyModel } from './model'
  import { mapQuery, Track } from '@/utils'
  import { wait } from 'vtils'

  export default Vue.extend({
    mixins: [
      mapQuery({
        // 标题
        t: {
          key: 't',
          default: '搜索结果',
        },
        // 关键词
        q: {
          key: 'q',
          default: undefined,
        },
        // 场景 ID
        s: {
          key: 's',
          default: '55f9be7e73c04949bfa7a0c850d33924',
        },
        // 关联类目
        l: {
          key: 'l',
          json: true,
          default: [],
        },
      }),
      Track.provideMark(() => ({
        page: '搜索结果',
      })),
    ],

    props: {
      pageProps: {
        type: Object,
        default: () => ({}),
      },
      martId: {
        type: String,
        default: '',
      },
    },

    data: () => ({
      title: '',
      keyword: '',
      searchId: '',
      total: 0,
      filterForm: {
        orderBy: 'none',
        orderType: 'none',
        available: false,
        discounted: false,
        minPrice: undefined,
        maxPrice: undefined,
        params: {},
      },
    }),

    watch: {
      async pageProps() {
        if (this.pageProps.loading === false) {
          await wait(0)
          this.$reloadWaterfall('goodsList')
        }
      },
      filterForm(_new, _old) {
        console.log(222, _new, _old)
        if (JSON.stringify(_new) !== JSON.stringify(_old)) {
          console.log(23322)

          this.$reloadWaterfall('goodsList')
        }
      },
    },

    mounted() {
      this.prepareData()
    },

    methods: {
      async prepareData() {
        this.title = this.t
        this.keyword = this.q
        this.$reloadWaterfall('goodsList')
      },
      async getQueryKeywords(keyword) {
        return apiSearchMartSearchSearchKeyword({
          keyword: keyword,
          refUserGroupId: currentChannelId,
        })
      },
      async handleLoadData({ pageNumber, source }) {
        const { list, searchId, total } =
          await apiSearchMartSearchSearchCommodity({
            pageIndex: pageNumber,
            pageSize: 10,
            // 筛选店铺时不处理运营渠道
            refUserGroupId: this.martId ? undefined : currentChannelId,
            refMartId: currentMall.mall_id,
            refMerchantId: this.martId,
            categoryIds: this.l,
            categoryParams: this.filterForm.params,
            inStockFlag: this.filterForm.available,
            promoteFlag: this.filterForm.discounted,
            minPrice: this.filterForm.minPrice || 0,
            maxPrice: this.filterForm.maxPrice || 99999,
            sceneId: this.s,
            searchWord: this.keyword,
            sortType:
              // 综合
              this.filterForm.orderBy === 'none'
                ? '02'
                : // 价格
                this.filterForm.orderBy === 'price'
                ? this.filterForm.orderType === 'desc'
                  ? '04'
                  : '03'
                : // 销量
                this.filterForm.orderType === 'desc'
                ? '01'
                : '00',
          })
        if (list.length && (!this.searchId || source === 'SearchConfirm')) {
          this.searchId = searchId
        }
        this.total = total
        return list
      },
      handleSearchConfirm(keyword, from) {
        this.$track.push({
          name: '搜索确定',
          id: 'clexmn5r1000ovprl8bsv2l4v',
          newId: 'SouSuo',
          content: keyword,
          extra: {
            search_scene_id: this.s,
            search_type: from,
            keyword: keyword,
          },
        })
        historyModel.add(keyword)
        this.filterForm = {
          orderBy: 'none',
          orderType: 'none',
          available: false,
          discounted: false,
          minPrice: undefined,
          maxPrice: undefined,
          params: {},
        }
        this.$reloadWaterfall('goodsList', 'SearchConfirm', true)
      },
    },
  })
</script>

<style lang="scss" module>
  .hd {
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: white;
    // 解决吸顶 1px 缝隙问题
    // https://www.cnblogs.com/2oex/p/11898544.html
    box-shadow: 0 -1px #fff;

    .searchBar {
      padding: 4px 12px;
    }

    &.custom {
      position: relative;
    }
  }

  .filterBar {
    &.custom {
      position: sticky;
      top: var(--real-page-header-height);
      z-index: 100;
      // 解决吸顶 1px 缝隙问题
      // https://www.cnblogs.com/2oex/p/11898544.html
      box-shadow: 0 -1px #fff;
    }
  }

  .list {
    padding: 12px;
  }
</style>
